// Shipping Date Card

class ShipDateCard {
  constructor() {
    const cards = document.querySelectorAll('.ship-date-card')

    if (cards.length > 0) {
      this.dateUpdate(cards);
    }
  }

  dateUpdate(cards) {
    
    cards.forEach(card => {
      const date = new Date()
      const currentMonth = date.getUTCMonth().toLocaleString('en-US', { timeZone: 'America/New_York' })
      const currentDay = date.getUTCDate().toLocaleString('en-US', { timeZone: 'America/New_York' })
      const cardMonth = card.dataset.month
      const cardDay = card.dataset.day

      if (parseInt(currentMonth) + 1 > parseInt(cardMonth) 
      || parseInt(currentMonth) + 1 === parseInt(cardMonth) && parseInt(currentDay) >= (parseInt(cardDay) + 1)
      ) {
        card.classList.add('disabled')
      }
    });
  }
}

const shipDateCardInit = {
  init() {
    // if element exists init this class
    const wrapperEl = document.querySelector('.ship-date-card');
    if (wrapperEl !== null) {
      // eslint-disable-next-line no-unused-vars
      new ShipDateCard(wrapperEl);
    }
  },
};

export default shipDateCardInit;
